export const ADD_INSURANCE = 'addInsurance';
export const DELETE_INSURANCE = 'deleteInsurance';
export const INVALID_INSURANCE = 'invalidInsurance';
